import { IAttributes } from 'src/app/models/IAttributes';

export class ASCMaster {
    attributeId: string;
    attributeType: string;
    attributeName: string;
    attributeDesc: string;
    createdBy: string;
    isActive: boolean;
    attributeObj : IAttributes;
    createInstance(attType : string,attName : string, attDescription : string) 
    {
    this.attributeObj= new IAttributes();  
    this.attributeObj.attributeType = attType
    this.attributeObj.attributeName = attName;
    this.attributeObj.attributeDesc = attDescription;
    this.attributeObj.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.attributeObj.isActive = true;
    return this.attributeObj;
    }

    updateInstance(attId: string,attType : string,attName : string, attDescription : string,isActive : boolean)
    {
    this.attributeObj= new IAttributes();  
    this.attributeObj.attributeId=attId;
    this.attributeObj.attributeType = attType
    this.attributeObj.attributeName = attName;
    this.attributeObj.attributeDesc = attDescription;
    this.attributeObj.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.attributeObj.isActive = isActive;
    return this.attributeObj;
    }

}
